<template>
  <clinician-icon v-if="iconType === 'clinician'" />
  <agency-icon v-else-if="iconType === 'agency'" />
  <message-icon v-else-if="iconType === 'message'" />
  <dictionary-icon v-else-if="iconType === 'dictionary'" />
  <expired-icon v-else-if="iconType === 'expired'" />
  <check-icon v-else-if="iconType === 'check'" />
  <default-icon v-else />
</template>

<script>
import { notificationTypes } from "../../constants/notificationTypes";

import ClinicianIcon from "../icons/notifications/ClinicianIcon";
import AgencyIcon from "../icons/notifications/AgencyIcon";
import DefaultIcon from "../icons/notifications/DefaultIcon";
import MessageIcon from "../icons/notifications/MessageIcon";
import DictionaryIcon from "../icons/notifications/DictionaryIcon";
import ExpiredIcon from "../icons/notifications/ExpiredIcon";
import CheckIcon from "../icons/notifications/CheckIcon";

export default {
  components: {
    ClinicianIcon,
    AgencyIcon,
    DefaultIcon,
    MessageIcon,
    DictionaryIcon,
    ExpiredIcon,
    CheckIcon,
  },
  props: {
    type: {
      default: '',
      type: String,
    },
  },
  computed: {
    iconType() {
      switch (this.type) {
        case notificationTypes.CLINICIAN_PROFILE_UPDATED:
        case notificationTypes.CLINICIAN_PROFILE_RECEIVED_FOR_REVIEW:
        case notificationTypes.OFFER_REJECTED_BY_CLINICIAN:
        case notificationTypes.VISIT_IS_COMPLETED_BY_CLINICIAN:
          return 'clinician'
        case notificationTypes.NEW_DOCUMENT_TYPE_ADDED:
        case notificationTypes.DICTIONARY_ATTRIBUTE_ADDED:
        case notificationTypes.DICTIONARY_ATTRIBUTE_UPDATED:
          return 'dictionary'
        case notificationTypes.VISIT_DATE_RANGE_EXPIRED:
        case notificationTypes.VISIT_SCHEDULED_DATE_EXPIRED:
          return 'expired'
        case notificationTypes.HA_PROFILE_UPDATED:
        case notificationTypes.HA_PROFILE_RECEIVED_FOR_REVIEW:
          return 'agency'
        case notificationTypes.HA_PROFILE_APPROVED:
          return 'check'
        case notificationTypes.NEW_MESSAGE_RECEIVED:
          return 'message'
        default:
          return 'default'
      }
    },
  },
}
</script>

<style scoped>

</style>
